import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

import colors from '../../styles/colors';
import LoadingPage from '../../components/LoadingPage';

const StyledToastContainer = styled(ToastContainer).attrs({
  className: 'toast-container',
})`
  min-width: 80%;
`;

const CreatingAccountOverlay = styled(LoadingPage)`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: ${colors.shades.dark1};
`;

const CreatingAccountMessage = styled.div`
  font-size: 16px;
  color: ${colors.base.alpha};
  text-align: center;
`;

export {
  StyledToastContainer,
  CreatingAccountOverlay,
  CreatingAccountMessage,
};
